import React, { useState, useEffect } from 'react';
import { useSpring } from 'react-spring';

import * as S from './styles';

type Props = {
  categories: string[];
  activeIndex: number;
  onItemSelect: (categoryIndex: number) => void;
  ariaControls: string;
  ariaLabel: string;
};

export const MobileFilterMenu = ({
  categories,
  activeIndex,
  onItemSelect,
  ariaControls,
  ariaLabel,
}: Props) => {
  const [offsetTop, setOffsetTop] = useState<number>(0);

  const [arrowTransition, set] = useSpring(
    () => ({
      transform: `translateY(${offsetTop}px)`,
    }),
    [activeIndex, offsetTop],
  );

  useEffect(() => {
    if (activeIndex > 0) {
      const activeItem = document.querySelector(
        `#item-${activeIndex}`,
      ) as HTMLButtonElement;
      if (activeItem && activeItem.offsetTop) {
        set({
          transform: `translateY(${activeItem.offsetTop}px)`,
          immediate: true,
        });
      }
    }
  }, []);

  const handleClick = (
    categoryIndex: number,
    e: React.SyntheticEvent<HTMLButtonElement>,
  ) => {
    const element = e.target as HTMLButtonElement;
    if (element) {
      setOffsetTop(element.offsetTop);
      onItemSelect(categoryIndex);
    }
  };

  return (
    <S.Wrapper>
      <S.CategoryLabel>Category</S.CategoryLabel>
      <S.CategoryList aria-label={ariaLabel} role="tablist">
        <S.AnimatedArrow style={arrowTransition}>
          <S.Arrow />
        </S.AnimatedArrow>
        {categories.map((category: string, i: number) => (
          <S.CategoryItem key={i}>
            <S.Category
              onClick={(e) => handleClick(i, e)}
              id={`item-${i}`}
              role="tab"
              aria-selected={i === activeIndex}
              aria-controls={ariaControls}
            >
              {category}
            </S.Category>
          </S.CategoryItem>
        ))}
      </S.CategoryList>
    </S.Wrapper>
  );
};

export default MobileFilterMenu;
